import { render, staticRenderFns } from "./SignatureRequirements.vue?vue&type=template&id=16651054&scoped=true"
import script from "./SignatureRequirements.vue?vue&type=script&lang=js"
export * from "./SignatureRequirements.vue?vue&type=script&lang=js"
import style0 from "./SignatureRequirements.vue?vue&type=style&index=0&id=16651054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16651054",
  null
  
)

export default component.exports